import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StandardGrowthModel } from 'src/app/Elearning-Models';

@Component({
  selector: 'app-standards-growth-popup',
  templateUrl: './standards-growth-popup.component.html',
  styleUrls: ['./standards-growth-popup.component.scss']
})
export class StandardsGrowthPopupComponent implements OnInit {

  standard: StandardGrowthModel;

  constructor(
    public dialogRef: MatDialogRef<StandardsGrowthPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,

    ) {
      this.standard = data.standard;
     }

  ngOnInit(): void {
  }

  checkForRedGrade(grade: string){
    var result = grade && parseInt(grade) < 70;
    return result;
  }

  checkForGreenGrade(grade: string){
    var result = grade && parseInt(grade) >= 70;
    return result;
  }

  onCancel(){
    this.dialogRef.close();
  }
}
